import { Link } from 'react-router';
import type { Animal } from '../dados/fonte.js';

interface Casa {
  papel: string;
  animal: Animal | undefined;
}

function Caixa({ papel, animal, raiz = false }: Casa & { raiz?: boolean }) {
  return (
    <div
      className={`flex h-full min-h-14 flex-col justify-center border px-3 py-2 ${
        raiz ? 'border-marca bg-marca text-sobre-marca' : 'border-borda bg-superficie'
      }`}
    >
      <span className={`text-xs font-semibold tracking-wide uppercase ${raiz ? 'opacity-75' : 'text-apagado'}`}>
        {papel}
      </span>
      {animal ? (
        raiz ? (
          <span className="font-serif font-semibold">{animal.name}</span>
        ) : (
          <Link to={`/animais/${animal.id}`} className="font-serif font-semibold text-destaque-texto hover:underline">
            {animal.name}
          </Link>
        )
      ) : (
        <span className="text-sm text-apagado">Não cadastrado</span>
      )}
    </div>
  );
}

/**
 * Arvore de duas geracoes, no formato de stud book: o animal, os pais e os
 * quatro avos. So mostra o que esta cadastrado; o resto aparece como tal.
 */
export function Genealogia({ animal, todos }: { animal: Animal; todos: readonly Animal[] }) {
  const buscar = (id: string | null) => (id ? todos.find((a) => a.id === id) : undefined);
  const pai = buscar(animal.sire_id);
  const mae = buscar(animal.dam_id);

  return (
    <div className="overflow-x-auto">
      <div className="grid min-w-[560px] grid-cols-3 grid-rows-4 gap-2">
        <div className="row-span-4">
          <Caixa papel="Animal" animal={animal} raiz />
        </div>
        <div className="row-span-2">
          <Caixa papel="Pai" animal={pai} />
        </div>
        <Caixa papel="Avô paterno" animal={buscar(pai?.sire_id ?? null)} />
        <Caixa papel="Avó paterna" animal={buscar(pai?.dam_id ?? null)} />
        <div className="row-span-2">
          <Caixa papel="Mãe" animal={mae} />
        </div>
        <Caixa papel="Avô materno" animal={buscar(mae?.sire_id ?? null)} />
        <Caixa papel="Avó materna" animal={buscar(mae?.dam_id ?? null)} />
      </div>
    </div>
  );
}
